export default "__VITE_ASSET__CHM3VZBT__"